import { Directive, Input, ElementRef, OnChanges, inject } from '@angular/core';
import { B2bService } from '../services/b2b.service';
import { StoreService } from '../services/store.service';
import { UserService } from '../services/user.service';

@Directive({
	selector: '[appGetBackground]',
})
export class GetBackgroundDirective implements OnChanges {
	@Input() CC?: string;
	@Input() Azmana?: boolean | string;
	@Input() Ahzara?: boolean | string;
	@Input() Azaha?: boolean | string;
	@Input() Stock?: number | string;

	// private _user = inject(UserService);
	private _b2b = inject(B2bService);

	constructor(private element: ElementRef, private _ss: StoreService) {}

	ngOnChanges() {
		const el: HTMLDivElement = this.element.nativeElement;

		if (this.CC != null) {
			let color = this.CC;

			if (typeof this.CC === 'string') this.CC = this.CC.toLowerCase();

			if (!this.CC) {
				color = 'grey';
			}

			// ? orange == magenta according to original code ?
			if (this.CC === 'orange') {
				color = 'magenta';
			}

			el.style.background = color;
		}

		if ((this.Azmana || this.Ahzara || this.Azaha) != null) {
			let color;

			if (this.Azmana && !this.Ahzara) {
				color = 'var(--valid-color)';
			}

			if (this.Azmana && this.Ahzara) {
				color = 'orange';
			}

			if (!this.Azmana && this.Ahzara) {
				color = 'var(--invalid-color)';
			}

			if (!this.Azmana && !this.Ahzara && this.Azaha) {
				color = 'blue';
			}

			el.style.background = color;
		}

		if (this.Stock != null) {
			if (isNaN(+this.Stock)) {
				throw new Error('Stock is not a number');
			}

			let color = '#fbbdb4';
			let n = 100;
			let n2 = 0;

			if (this._ss.CustomerInformation.StockQuantity && this._ss.CustomerInformation.StockQuantity !== '0') {
				const split = (this._ss.CustomerInformation.StockQuantity as string).split('_');
				[n, n2] = split.reverse().map(Number);
				if (!isFinite(n2)) n2 = 0;
			}

			if (this._ss.CustomerInformation.B2BStockQuantity && this._ss.CustomerInformation.B2BStockQuantity !== '0' && this._b2b.isB2BAgent$.value) {
				const split = (this._ss.CustomerInformation.B2BStockQuantity as string).split('_');
				[n, n2] = split.reverse().map(Number);
				if (!isFinite(n2)) n2 = 0;
			}

			if (+this.Stock >= n) {
				color = 'var(--valid-color)';
			}

			if (+this.Stock < n && +this.Stock > n2) {
				color = 'yellow';
			}

			el.style.background = color;
		}
	}
}
